import { Box } from "@material-ui/core";
import React, { useContext } from "react";
import { AutorizacaoEspecialContext } from "../../../../context/AutorizacaoEspecialContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import AutorizacaoEspecialDeclaration from "../../../components/materialui/AutorizacaoEspecial/termsDeclarations/AutorizacaoEspecialDeclaration";


export default function TermsDeclarationsStep() {

    const { state, dispatch } = useContext(AutorizacaoEspecialContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    return (
        <div>
            <Steps.StepTitle text="Termos e Declarações" />

            <Box mt={2} minHeight="300px">
                <AutorizacaoEspecialDeclaration
                    TermsDeclarationsForm={state.TermsDeclarationsForm}
                    onInputChange={onInputChange} />

            </Box>

        </div>
    );
}